import basic_year_table_vue_vue_type_script_setup_true_lang_default from "./basic-year-table.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/date-picker-panel/src/date-picker-com/basic-year-table.vue
var basic_year_table_default = basic_year_table_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { basic_year_table_default as default };
//# sourceMappingURL=basic-year-table.mjs.map